<script>
import Layout from '@layouts/primary'
import { clientMethods, authMethods } from '@state/helpers'
import store from '@state/store'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'My Account',
    meta: [{ name: 'my_account', content: 'My Account' }],
  },
  components: { Layout },
  data() {
    return {
      password: '',
      passwordconfirm:'',
      authError: null,
      matchError:null,
      submitted:false,
      editClient:false,
      changePwd: false,
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      client: {},
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
    }
  },
  mounted() {
    let that = this
    let cid = store.getters['auth/getClientId'];
    this.$validator.localize('en', this.dictionary)
    this.getClientById({id: cid}).then(response => {
      that.client = this.$store.state.clients.currentClient
      let formattedObj = {
        ...that.client
      };
      that.client = formattedObj
    })
  },
  methods: {
    ...clientMethods, ...authMethods,
    update() {
      this.$validator.validateAll()
      this.client.id = parseInt(this.client.id)
      this.client.postcode = parseInt(this.client.postcode);
      this.createClientRequest(this.client)
      this.editClient = !this.editClient
    },
    async resetPassword() {
      // Reset the authError if it existed.
      this.authError = null;
      this.matchError = null;
      if(this.password.length < 1){
        this.matchError = true;
        return
      }
      if(this.password !== this.passwordconfirm){
        this.authError = true
      }else{
        let user = store.getters['auth/getCurrentUser'];
        await this.updateClientPassword({
          id: user.client_id,
          password: this.password,
        })
          .then(response => {
            this.submitted = true;
            location.reload()
          })
          .catch(error => {
            // console.log(error)
            // this.tryingToLogIn = false
            this.authError = error
          })
      }

    },
    closePwdModal(){
      this.changePwd = !this.changePwd;
    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <VCard class="v-card-padding top-blue client-card">
        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            sm8
            md8
            lg8
            class="client-details"
          >
            <h3>{{ client.client_name }}</h3>
            <br>
            <p><i class="fas fa-user" /> {{ client.contact_name }}</p>
            <p><i class="fas fa-map-marker" /> {{ client.address }}, {{ client.suburb }} {{ client.postcode }}</p>
            <p><i class="fas fa-id-badge" /> ABN: {{ client.abn }} </p>
            <p><i class="fas fa-id-card" /> Driver License: {{ client.drivers_licence }}</p>
          </VFlex>
          <VFlex
            xs12
            sm4
            md4
            lg4
          >
            <h5>Contact Details</h5>
            <br>
            <p><i class="fas fa-envelope" /> {{ client.email }}</p>
            <p><i class="fas fa-phone" /> {{ client.phone }}</p>
            <p><i class="fas fa-mobile-alt" /> {{ client.mobile }}</p>
            <p><i class="fas fa-fax" /> {{ client.fax }}</p>
          </VFlex>
        </VLayout>
        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            sm3
            md4
            lg3
          >
            <VBtn
              color="blue"
              block
              @click.native="editClient = !editClient"
            >
              EDIT DETAILS
            </VBtn>
          </VFlex>

          <VFlex
            xs12
            sm3
            md4
            lg3
          >
            <VBtn
              color="blue"
              block
              outline
              @click.native="changePwd = !changePwd"
            >
              CHANGE PASSWORD
            </VBtn>
          </VFlex>
        </VLayout>
      </vcard>
    </VContainer>

    <!-- CHANGE PASSWORD MODAL -->
    <VDialog
      v-model="changePwd"
      persistent
      max-width="500px"
      scrollable
    >
      <VCard>
        <VCardText>
          <VContainer grid-list-md>
            <h2>Change Password</h2>
            <VLayout wrap>
              <VFlex
                xs12
                sm12
              >
                <VTextField
                  v-model="client.current_password"
                  label="Current Password"
                  data-vv-name="current_password"
                  required
                  :append-icon="showCurrentPassword ? 'visibility_off' : 'visibility'"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  @click:append="showCurrentPassword = !showCurrentPassword"
                />
              </VFlex>
              <VFlex
                xs12
                sm12
              >
                <VTextField
                  v-model="password"
                  label="New Password"
                  data-vv-name="new_password"
                  required
                  :append-icon="showNewPassword ? 'visibility_off' : 'visibility'"
                  :type="showNewPassword ? 'text' : 'password'"
                  @click:append="showNewPassword = !showNewPassword"
                />
              </VFlex>
              <VFlex
                xs12
                sm12
              >
                <VTextField
                  v-model="passwordconfirm"
                  label="Confirm Password"
                  data-vv-name="confirm_password"
                  required
                  :append-icon="showConfirmPassword ? 'visibility_off' : 'visibility'"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                />
              </VFlex>

              <VSpacer />

              <VFlex
                xs12
                sm6
                md6
              >
                <VBtn
                  color="blue"
                  block
                  outline
                  @click.native="closePwdModal()"
                >
                  Close
                </VBtn>
              </VFlex>
              <VFlex
                xs12
                sm6
                md6
              >
                <VBtn
                  color="blue"
                  block
                  @click.native="resetPassword()"
                >
                  Save
                </VBtn>
              </VFlex>
              <p
                v-if="authError"
                :class="$style.error"
              >
                Passwords do not match
              </p>
              <p
                v-if="matchError"
                :class="$style.error"
              >
                Password cannot be empty
              </p>
            </VLayout>
          </VContainer>
        </VCardText>
      </VCard>
    </VDialog>

    <!-- Update Client MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="editClient"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Update Client: {{ client.client_name }}</h2>
              <VLayout wrap>

                <VFlex
                  xs12
                  sm12
                >
                  <VTextField
                    v-model="client.abn"
                    v-validate="'required'"
                    label="ABN"
                    data-vv-name="abn"
                    required
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.address"
                    label="Address"
                    data-vv-name="address"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.suburb"
                    label="Suburb"
                    data-vv-name="suburb"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.postcode"
                    v-validate="'required|integer'"
                    label="Postcode"
                    data-vv-name="postcode"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.phone"
                    v-validate="'integer'"
                    label="Phone"
                    data-vv-name="phone"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.fax"
                    v-validate="'integer'"
                    label="Fax"
                    data-vv-name="fax"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.mobile"
                    v-validate="'integer'"
                    label="Mobile"
                    data-vv-name="mobile"
                    required
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.title"
                    label="Title"
                    data-vv-name="title"
                    required
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="client.contact_name"
                    v-validate="'required'"
                    label="Contact Name"
                    data-vv-name="contact_name"
                    required
                  />
                </VFlex>

                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="editClient = !editClient"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="update()"
                  >
                    Request Changes
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
  </Layout>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
      display: inline-block;
    }

    .addButton {
      display: inline-block;
      float: right;
    }

    .client-card{
      border: 0 solid $blue;
      border-top-width: 10px;
    }

    .error{
      width: 100%;
      padding:25px 25px 0 25px;
      color: red;
      text-align: center;
    }
</style>
